// Unpublished Work © 2023 Deere & Company.

import {SET_DBS_CUSTOMER_PROFILE_ERROR} from '../../action-list';
import {DbsCustomerError} from '../../state/struct/dbs-customer-profile/dbs-customer-error';

const setDbsCustomerError = (state, action) => new DbsCustomerError(action.dbsCustomerError);

export function dbsCustomerError(state = new DbsCustomerError({}), action = {}) {
    const actionHandlers = {
        [SET_DBS_CUSTOMER_PROFILE_ERROR]: setDbsCustomerError
    };

    const reducer = actionHandlers[action.type];

    return reducer ? reducer(state, action) : state;
}
